/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hour: NonNullable<unknown>, minute: NonNullable<unknown> }} Station_Work_Speech_TimeInputs */

const vi_station_work_speech_time = /** @type {(inputs: Station_Work_Speech_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} giờ ${i?.minute}`)
};

/**

* @param {Station_Work_Speech_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_speech_time = /** @type {((inputs: Station_Work_Speech_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Speech_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_speech_time(inputs)
});